import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const UserMenuTitleDefaultBox = styled.div`
    /* .user-menu-box-title */
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0.5rem 0;
    font-size: 1.4rem;
    font-family: ${({theme}) => theme.font.family.regular};
    color: ${({theme}) => theme.colors.userMenuTitleText};
`;

/* 777 */
const UserMenuTitleCasino777Box = styled(UserMenuTitleDefaultBox)`
    margin-top: 2rem;
    font-size: 1.6rem;
    font-family: ${({theme}) => theme.font.family.bold};
    font-weight: 900;
`;

export const UserMenuTitleBox = styledByTheme(UserMenuTitleDefaultBox).forCasino777(UserMenuTitleCasino777Box).apply();
